import { createConfirmation } from "react-confirm";
import LocationModal from "./LocationModal";

export const showLocationModal = createConfirmation(LocationModal);
